import styled from 'styled-components';
import { Button, lightenDarkenColor } from '../shared/utils/styles';

export const Container = styled.div`
  grid-area: tbar;
  z-index: 1;
  height: 50px;
  width: ${(props) => (props.zoomLevel < 1 ? '101%' : '100vw')};
  margin-left: -10px;
  padding: 0px;
  background-color: rgba(0, 0, 0, 0.8);
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-areas: 'btns title right';
  color: #ffffff;
  justify-items: center;
`;

export const LeftSide = styled.div`
  grid-area: btns;
  display: flex;
  justify-self: left;
  align-self: center;
  width: 100%;
  padding-left: 20px;
`;

export const RightSide = styled.div`
  grid-area: right;
  justify-self: right;
  align-self: center;
  margin-right: 100px;
  /* width: 100%; */
`;

export const Title = styled.h2`
  grid-area: title;
`;


export const LaunchPadButton = styled(Button)`
  font-weight: normal;
  background-color: #0095E8;
  min-width: max-content;
  color: #ffffff;
  &:hover {
    background-color: ${lightenDarkenColor('#0095E8', 20)};
    color: #ffffff;
  }
`;

export const FlexRow = styled.div`
  display: flex;

  && ${LaunchPadButton} {
    margin-left: 10px;
  }
`;